import {
  endOfDay,
  endOfISOWeek,
  endOfMonth,
  interval,
  startOfDay,
  startOfISOWeek,
  startOfMonth,
  subDays,
  subMonths,
  subWeeks,
} from "date-fns";
import { useTranslation } from "react-i18next";

import { DateRangePicker } from "components/DateRangePicker/DateRangePicker";

type Value = { start: Date; end: Date; type: string };

type TimeStampFilterProps = {
  value: Value;
  onChange: (value: Value) => void;
};

function TimeStampFilter({ value, onChange }: TimeStampFilterProps) {
  const { t } = useTranslation();

  return (
    <DateRangePicker
      value={value}
      onChange={onChange}
      options={[
        {
          key: "today",
          label: t("today"),
          value: interval(startOfDay(new Date()), endOfDay(new Date())),
        },
        {
          key: "yesterday",
          label: t("yesterday"),
          value: interval(
            startOfDay(subDays(new Date(), 1)),
            endOfDay(subDays(new Date(), 1)),
          ),
        },
        {
          key: "this_week",
          label: t("this_week"),
          value: interval(startOfISOWeek(new Date()), endOfISOWeek(new Date())),
        },
        {
          key: "last_week",
          label: t("last_Week"),
          value: interval(
            subWeeks(startOfISOWeek(new Date()), 1),
            subWeeks(endOfISOWeek(new Date()), 1),
          ),
        },
        {
          key: "this_month",
          label: t("this_month"),
          value: interval(startOfMonth(new Date()), endOfMonth(new Date())),
        },
        {
          key: "last_month",
          label: t("last_month"),
          value: interval(
            subMonths(startOfMonth(new Date()), 1),
            subMonths(endOfMonth(new Date()), 1),
          ),
        },
      ]}
      dateFormatStr={"PP"}
    />
  );
}

export default TimeStampFilter;
